import { ref, watch, computed } from '@vue/composition-api'
import axios from 'axios'

// Notification
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { getToken } from '@/auth/utils'

export default function useContractsList() {
  const toast = useToast()
  const refContractsListTable = ref(null)

  const tableColumns = [
    { key: 'Code', sortable: true },
    { key: 'AgreementRef', label: 'Agreement Ref', sortable: true },
    { key: 'Customer', sortable: true },
    { key: 'Description', sortable: true },
    { key: 'IssuedDate', label: 'Issued Date', sortable: true },
    { key: 'StartDate', label: 'Start Date', sortable: true },
    { key: 'EndDate', label: 'End Date', sortable: true },
    { key: 'IssuedBy', label: 'Issued By', sortable: true },
    { key: 'actions', label: 'Attachments' },
  ]

  const perPage = ref(10)
  const perPageOptions = [10, 20, 50, 100]
  const totalContracts = ref(0)
  const currentPage = ref(1)
  const searchQuery = ref('')
  const sortBy = ref('IssuedDate')
  const isSortDirDesc = ref(true)

  let searchDebounce = null

  const dataMeta = computed(() => {
    const localItemsCount = refContractsListTable.value ? refContractsListTable.value.localItems.length : 0
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalContracts.value,
    }
  })

  const refetchData = () => {
    refContractsListTable.value.refresh()
  }

  // Page/perPage refetch langsung, search di-debounce biar gak nembak
  // request tiap ketikan huruf (pola sama kayak useUsersList).
  watch([currentPage, perPage], () => {
    refetchData()
  })

  watch(searchQuery, () => {
    currentPage.value = 1
    if (searchDebounce) clearTimeout(searchDebounce)
    searchDebounce = setTimeout(() => {
      refetchData()
    }, 400)
  })

  const fetchContracts = (ctx, callback) => {
    const userToken = getToken()
    const headers = {
      'Content-Type': 'application/json',
      'X-Token-Access': `Bearer ${userToken}`,
    }

    axios
      .get('https://api.geolims.com/invoice_service/getContractList', {
        headers,
        params: {
          page: currentPage.value,
          perPage: perPage.value,
          search: searchQuery.value,
        },
      })
      .then(response => {
        const { Contracts, Total } = response.data
        totalContracts.value = Total !== undefined ? Total : Contracts.length
        callback(Contracts)
      })
      .catch(error => {
        console.log(error)
        toast({
          component: ToastificationContent,
          props: {
            title: 'Error fetching contract list',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      })
  }

  return {
    fetchContracts,
    tableColumns,
    perPage,
    perPageOptions,
    currentPage,
    totalContracts,
    dataMeta,
    searchQuery,
    sortBy,
    isSortDirDesc,
    refContractsListTable,
    refetchData,
  }
}
